import { jsx as _jsx } from "react/jsx-runtime";
import { useDialectGate } from '@dialectlabs/react-sdk';
import FailingGateError from '../../entities/errors/ui/FailingGateError';
function GatedWrapper({ gatedView, children }) {
    const { isGatePassed, isGateLoading } = useDialectGate();
    if (!isGatePassed) {
        return !gatedView || typeof gatedView === 'string' ? (_jsx(FailingGateError, { message: gatedView, isLoading: isGateLoading })) : (gatedView);
    }
    return children;
}
export default GatedWrapper;
//# sourceMappingURL=GatedWrapper.js.map